import { Trans, useLingui } from '@lingui/react/macro';
import type { ReactNode } from 'react';
import surface from './ProjectSurface.module.css';

interface Props {
  title: string;
  end?: ReactNode;
  className?: string;
}

/** Shared heading hierarchy for Project-level resource pages. */
export default function ProjectPageHeader({ title, end, className }: Props) {
  const { t, i18n } = useLingui();
  return (
    <header
      className={[surface.pageContainer, surface.pageHeader, className].filter(Boolean).join(' ')}
    >
      <div>
        <span className={surface.eyebrow}>
          <Trans>Project</Trans>
        </span>
        <h1 className={surface.pageTitle}>{title}</h1>
      </div>
      {end}
    </header>
  );
}
